/* eslint-disable import/prefer-default-export */
export function sequenceIdsSelector(state) {
  if (!state.models.outline) {
    return [];
  }
  const { sequences } = state.models.outline[state.courseware.courseId].courseBlocks;
  const sequenceIds = Object.keys(sequences);

  return sequenceIds;
}
